/**
 * Anhangsarten an Aufträgen laut AV-204 (#6690).
 * Referenz: docs/auftragsverwaltung/AV-204-kranfotodokumentation-boot.md
 */

export enum OrderAttachmentKind {
    General = 'general',
    CranePhoto = 'crane_photo',
    PositionPhoto = 'position_photo',
}

const ORDER_ATTACHMENT_KINDS = new Set<string>(Object.values(OrderAttachmentKind));

export function isOrderAttachmentKind(value: unknown): value is OrderAttachmentKind {
    return typeof value === 'string' && ORDER_ATTACHMENT_KINDS.has(value);
}

export function normalizeOrderAttachmentKind(value: unknown): OrderAttachmentKind {
    if (isOrderAttachmentKind(value)) {
        return value;
    }

    return OrderAttachmentKind.General;
}

export function isBoatLinkedOrderAttachmentKind(kind: OrderAttachmentKind): boolean {
    return kind === OrderAttachmentKind.CranePhoto
        || kind === OrderAttachmentKind.PositionPhoto;
}

export function resolveOrderAttachmentKindLabelKey(kind: OrderAttachmentKind): string {
    switch (kind) {
        case OrderAttachmentKind.CranePhoto:
            return 'boats.documents.orderPhotosKind.cranePhoto';
        case OrderAttachmentKind.PositionPhoto:
            return 'boats.documents.orderPhotosKind.positionPhoto';
        default:
            return 'widgets.docksite.orderDetailV2.attachments.kind.general';
    }
}
